import React from 'react';
import PropTypes from 'prop-types';

const NextEvent = ({ description, title }) => (
  <li className="next-event">
    <h3>{title}</h3>
    <div>{description}</div>
  </li>
);

NextEvent.propTypes = {
  description: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
};

export default NextEvent;
